import { mapActions, mapGetters } from 'vuex'

import { isArrayNotEmpty, isStringNotEmpty, states } from '@/utils'

import render from './render'

const presetType = {
  doc: [
    '.doc',
    '.docx',
    'application/msword',
    'application/vnd.oasis.opendocument.text',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ],
  csv: [ '.csv' ],
  xls: [ '.xls' ],
  xlsx: [ '.xlsx' ],
  gif: [ '.gif', 'image/gif' ],
  jpg: [ '.jpg', '.jpeg', 'image/jpeg' ],
  png: [ '.png', 'image/png' ],
  svg: [ '.svg', 'image/svg+xml' ],
  wav: [ '.wav', '.mp3' ],
  pdf: [ '.pdf' ]
}

export default {
  name: 'FileDrop',

  props: {
    multiple: {
      type: Boolean,
      default: false
    },

    name: {
      type: [ String, Boolean ],
      default: 'file'
    },

    accepted: [ String, Array ],

    url: {
      type: String,
      default: '/storage'
    },

    method: {
      type: String,
      default: 'POST'
    },

    maxFileSize: {
      type: Number,
      default: 20971520
    },

    loading: Boolean,
    disabled: Boolean,
    isPublic: Boolean,

    type: {
      type: String,
      default: 'card'
    }
  },

  data() {
    return {
      isDragActive: false
    }
  },

  computed: {
    ...mapGetters({ state: 'file/state' }),

    isLoading() {
      return this.loading || this.state === states.loading
    },

    isDisabled() {
      return this.disabled || this.isLoading
    },

    resolvedAccepted() {
      let resolvedAccepted = []
      const accepted = this.accepted

      if (isArrayNotEmpty(accepted)) {
        resolvedAccepted = accepted.reduce((result, type) => {
          if (presetType[type]) {
            result.push(...presetType[type])
          } else {
            result.push(type)
          }

          return result
        }, [])
      } else if (isStringNotEmpty(accepted)) {
        resolvedAccepted = [ accepted ]
      }

      if (resolvedAccepted.length) {
        return resolvedAccepted.join(',')
      }

      return false
    }
  },

  methods: {
    ...mapActions({
      handler: 'file/handler',
      setAttributes: 'file/setAttributes'
    }),

    async setCurrentAttributes() {
      await this.setAttributes({
        isPublic: this.isPublic || undefined,
        multiple: this.multiple || undefined,
        name: this.name || undefined,
        types: this.resolvedAccepted || undefined,
        url: this.url || undefined,
        method: this.method || undefined,
        maxFileSize: this.maxFileSize || undefined
      })
    },

    activateDropArea(event) {
      if (this.isDisabled) {
        return
      }

      event.preventDefault()
      document.body.classList.add('dragover')
      this.isDragActive = true
    },

    deactivateDropArea(event) {
      if (event) {
        event.preventDefault()
      }

      document.body.classList.remove('dragover')
      this.isDragActive = false
    },

    async handleDrop(event) {
      if (this.isDisabled) {
        return
      }

      event.preventDefault()
      await this.setCurrentAttributes()
      this.handler(event)
      this.deactivateDropArea(event)
    },

    async openFileDialog() {
      const file = document.getElementById('file')

      await this.setCurrentAttributes()

      if (!this.isDisabled && file) {
        file.click()
      }
    },

    handleClick(event) {
      if (event) {
        event.stopPropagation()
      }

      if (!this.isDisabled) {
        switch (this.type) {
          case 'button': {
            this.openFileDialog()

            return
          }

          default: {
            this.$emit('click')
          }
        }
      }
    }
  },

  render
}
